import clsx from 'clsx'
import React from 'react'
import {makeStyles} from 'external/material'
import Box from '@mui/material/Box'
import Radio from '../Radio'
import RadioGroup from '@mui/material/RadioGroup'
import Fade from '@mui/material/Fade'
import FormControlLabel from '@mui/material/FormControlLabel'
import StatusIcon from '../StatusIcon'

const useStyles = makeStyles(trueOrFalseStyles)

export default function TrueOrFalse (props) {
  const {context} = props
  const classes = useStyles()
  const {translate} = context

  return (
    <Box className={classes.root}>
      <RadioGroup className="content">
        <Box className={classes.option}>
          <Box className={classes.radio}>
            <FormControlLabel value={false} control={<Radio checked={false} />} label={translate('true')} />
          </Box>
        </Box>
        <Box className={classes.option}>
          <Box className={classes.radio}>
            <FormControlLabel value={false} control={<Radio checked={false} />} label={translate('false')} />
          </Box>
        </Box>
      </RadioGroup>
    </Box>
  )
}

function trueOrFalseStyles (theme) {
  return {
    root: {
    },
    option: {
      display: 'flex'
    }
  }
}
